import { Box, Grid, Typography } from "@mui/material";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import DashBoardCards from "../Home/DashboardCard";
import {
  WorkOutline,
  PauseCircleOutline,
  Block,
  CheckCircleOutline,
  HourglassEmpty,
  PlayCircleOutline,
  TrendingUp,
  WarningAmber,
  Schedule,
} from "@mui/icons-material";
import TotalProjectCard from "./components/TotalProjectCard";
import PieChart from "./components/PieChart";
import ResourceAllocation from "./components/ResourceAllocation";
import ProjectStatusCard from "./components/ProjectStatusCard";
import ProjectStatusTable from "./components/ProjectStatusTable";
import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../Utils/Baseurl";


const Dashboards = () => {

  const [currentPage, setCurrentPage] = useState(1);
  const [dashboardData, setDashboardData] = useState([]);
  const [projectTable, setProjectTable] = useState([]);
  const [milestoneTable, setMilestoneTable] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);


  const rows = projectTable && projectTable.length > 0
    ? projectTable.map((item) => ({
      id: item.id,
      code: item.project_code,
      name: item.project_name,
      spi: item.spi,
      cpi: item.cpi,
      status: item.status,
      manager: item.manager_name || `${item.manager}`,
      date: item.end_date,
      completion: parseInt(item.completion_percentage),
    }))
    : [];

  const rowsPerPage = 5;
  const totalPages = Math.ceil(rows.length / rowsPerPage);

  useEffect(() => {
    fetchDashboardData();
    fetchDashbaord();
  }, [])

  useEffect(() => {
    fetchProjectStatus(selectedCard || "Total Project");
  }, [selectedCard]);

  const handleCardClick = (statusKey) => {
    setSelectedCard(statusKey);
  };

  const cardData = [
    {
      title: "On Hold",
      count: 12,
      score: dashboardData?.hold,
      icon: <PauseCircleOutline />,
      color: "#ff9800", // Orange
      description: "Projects currently paused",
      statusKey: "Hold"
    },
    {
      title: "Aborted",
      count: 5,
      score: dashboardData?.abort,
      icon: <Block />,
      color: "#f44336", // Red
      description: "Projects stopped permanently",
      statusKey: "Abort"
    },
    {
      title: "Completed",
      count: 48,
      score: dashboardData?.completed,
      icon: <CheckCircleOutline />,
      color: "#4caf50", // Green
      description: "Projects successfully delivered",
      statusKey: "Completed"
    },
    {
      title: "Not Started",
      count: 20,
      score: dashboardData?.not_Started,
      icon: <HourglassEmpty />,
      color: "#9e9e9e", // Grey
      description: "Projects yet to begin",
      statusKey: "Not Started"
    },
    {
      title: "In Progress",
      count: 25,
      score: dashboardData?.in_Progress,
      icon: <PlayCircleOutline />,
      color: "#2196f3", // Light Blue
      description: "Projects currently under execution",
      statusKey: "In Progress"
    },
    {
      title: "On Track",
      count: 30,
      score: dashboardData?.projects_on_track,
      icon: <TrendingUp />,
      color: "#66bb6a", // Light Green
      description: "Projects progressing as per schedule",
      statusKey: "on-track"
    },
    {
      title: "At Risk",
      count: 8,
      score: dashboardData?.projects_at_risk_count,
      icon: <WarningAmber />,
      color: "#ff5722", // Deep Orange
      description: "Projects that may face issues",
      statusKey: "at-risk"
    },
    {
      title: "Behind Schedule",
      count: 10,
      score: dashboardData?.projects_behind_count,
      icon: <Schedule />,
      color: "#ab47bc", // Purple
      description: "Projects delayed compared to timeline",
      statusKey: "behind"

    },
  ];

  const series = [
    dashboardData?.hold ?? 0,
    dashboardData?.abort ?? 0,
    dashboardData?.not_Started ?? 0,
    dashboardData?.in_Progress ?? 0,
    dashboardData?.completed ?? 0,
  ];

  const options = {
    labels: ["On Hold", "Abort", "Not started", "In Progress", "Completed"],
    colors: ["#FB9413", "#B32222", "#576F78", "#0998E1", "#1E6124"],
    legend: {
      position: "bottom",
    }
  };

  const seriesInProgress = [
    dashboardData?.projects_on_track ?? 0,
    dashboardData?.projects_at_risk_count ?? 0,
    dashboardData?.projects_behind_count ?? 0,
  ];

  const optionsInProgress = {
    labels: ["On track", "At risk", "Behind"],
    colors: ["#99C766", "#FF6600", "#FF0000"],
    legend: {
      position: "bottom",
    }
  };

  const totalProjectCardData = {
    title: "Total Projects",
    score: dashboardData?.total_project,
    icon: <WorkOutline />,
    bgColor: "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(107, 0, 159, 0.1) 100%)",
    fontColor: "#6B009F",
    borderLeft: "10px solid #6B009F",
  }

  const fetchDashboardData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}api/dashboard/`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      setDashboardData(response.data.data);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  const fetchDashbaord = async () => {
    try {
      const response = await axios.get(`${BASE_URL}api/projectTable/`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      setProjectTable(response.data.data);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  const fetchProjectStatus = async (status) => {
    try {
      const response = await axios.get(`${BASE_URL}api/projectTable/${status}/`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      setMilestoneTable(response.data.data)
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  }

  return (
    <DashboardLayout>
      <>
        {dashboardData && projectTable && milestoneTable ? (
          <>
            <Grid container direction='row' spacing={3}>
              <Grid size={{ xs: 12, sm: 8 }}> {/* Parent left side */}
                <Grid container direction='column' spacing={2}>
                  <Grid size={{ xs: 12, sm: 12 }}>{/* Parent left top */}
                    <Grid container direction='row' spacing={1}>
                      <Grid size={{ xs: 12, sm: 2 }}>
                        <TotalProjectCard totalProjectCardData={totalProjectCardData} dashboardData={dashboardData} onClick={handleCardClick} />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 10 }}>
                        <Grid container direction='row' spacing={1}>
                          {cardData?.map((card, i) => (
                            <Grid size={{ xs: 6, sm: 3 }} key={i} gap={0}>
                              <DashBoardCards
                                title={card.title}
                                score={card.score}
                                icon={card.icon}
                                statusKey={card.statusKey}
                                onClick={handleCardClick}
                                bgColor={
                                  i === 0
                                    ? "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%,rgba(251, 148, 19, 0.4) 100%)"
                                    : i === 1
                                      ? "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(179, 34, 34, 0.4) 100%)"
                                      : i === 2
                                        ? "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(30, 97, 36, 0.4) 100%)"
                                        : i === 3
                                          ? "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(87, 111, 120, 0.4) 100%)"
                                          : i === 4
                                            ? "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%,rgba(9, 152, 225, 0.4) 100%)"
                                            : i === 5
                                              ? "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(153, 199, 102, 0.4) 100%)"
                                              : i === 6
                                                ? "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 102, 0, 0.4)100%)"
                                                : i === 7
                                                  ? "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 0, 0, 0.4) 100%)"
                                                  : "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(171, 71, 188, 0.4) 100%)"
                                }
                                fontColor={
                                  i === 0
                                    ? "#FB9413"
                                    : i === 1
                                      ? "#B32222"
                                      : i === 2
                                        ? "#1E6124"
                                        : i === 3
                                          ? "#576F78"
                                          : i === 4
                                            ? "#0998E1"
                                            : i === 5
                                              ? "#99C766"
                                              : i === 6
                                                ? "#FF6600"
                                                : i === 7
                                                  ? "#FF0000"
                                                  : "#AB47BC"
                                }
                                borderLeft={
                                  i === 0
                                    ? "10px solid #FB9413"
                                    : i === 1
                                      ? "10px solid #B32222"
                                      : i === 2
                                        ? "10px solid #1E6124"
                                        : i === 3
                                          ? "10px solid #576F78"
                                          : i === 4
                                            ? "10px solid #0998E1"
                                            : i === 5
                                              ? "10px solid #99C766"
                                              : i === 6
                                                ? "10px solid #FF6600"
                                                : i === 7
                                                  ? "10px solid #FF0000"
                                                  : "10px solid #AB47BC"
                                }
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12 }}>{/* Parent left bottom */}
                    <Grid container direction='row' spacing={2} sx={{ paddingLeft: 2 }}>
                      <Grid size={{ xs: 12, sm: 4 }}>
                        <PieChart series={series} options={options} centerText="Total Project" />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 4 }}>
                        <ResourceAllocation dashboardData={dashboardData} />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 4 }}>
                        <PieChart series={seriesInProgress} options={optionsInProgress} centerText="In Progress" />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12, sm: 4 }}>{/* Parent right side */}
                <ProjectStatusCard milestoneTable={milestoneTable} />
              </Grid>
            </Grid>
            <Grid container spacing={2} marginLeft={2}>
              <Grid size={{ xs: 12, sm: 12 }}>
                <ProjectStatusTable
                  rows={rows}
                  currentPage={currentPage}
                  rowsPerPage={rowsPerPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />
              </Grid>
            </Grid>
          </>
        ) : (
          <Box
            sx={{
              width: "100%",
              height: "80vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" color="textSecondary" sx={{ textAlign: "center", fontFamily: 'A' }}>Loading...Wait for few seconds your data is getting ready</Typography>
          </Box>
        )}
      </>
    </DashboardLayout>
  )
}
export default Dashboards;